function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScCalendar = function SvgScCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "M22 5V4a1 1 0 0 0-1-1h-7m8 2v15a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5m20 0H2m0 0V4a1 1 0 0 1 1-1h3m0 0V0m0 3h4m0 0V0m0 3h4m0 0V0m4 3V0M9 9h2m2 0h2M5 13h2m2 0h2m2 0h2m2-4h2m-2 4h2M5 17h2m2 0h2m2 0h2",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScCalendar;